import { Controller } from "@hotwired/stimulus";
import { application } from "src";
import { toMilliseconds } from "@fretadao/f-js-utils";

application.register('ride-request-vouchers', class extends Controller {
  defaultReloadInSeconds = 20;

  connect() {
    setTimeout(() => window.location.reload(), toMilliseconds(this.defaultReloadInSeconds, 'seconds'));
  }
});
